import React, { useEffect, useState, memo } from 'react';
import { Modal, Button } from 'semantic-ui-react';
import { useSelector, useDispatch } from 'react-redux';
import { func, shape, number } from 'prop-types';
import { searchDoctors } from 'Redux/modules/search/teleconsult/actions';
// import { updateEntities } from 'Redux/modules/entities/actions';
import {
  inviteDoctorsToConsult,
  resetInvitationState,
} from 'Redux/modules/webChat/invitation/actions';
// import { WEBCHAT } from 'Constants/normalize-module';

import DoctorList from './DoctorList';
import ModuleSearch from './ModuleSearch';
import DoctorSelected from './DoctorSelected';

const limit = 10;
let offset = 0;
let interval = null;

const ModalDoctorInvite = ({ close, conversationActive, doctorId }) => {
  const [search, setSearch] = useState('');
  const [selectedDoctor, setSelectedDoctor] = useState([]);

  const dispatch = useDispatch();
  const {
    status: { loadDoctor },
    doctors,
    meta,
  } = useSelector(state => state.search.teleconsult);
  const invitation = useSelector(state => state.webChat.invitation);

  const {
    latestConsult: {
      id: consultId,
      patient: { id: patientId },
      forPatient: { id: forPatientId },
    },
  } = conversationActive;

  const {
    status: { creatingInvitation },
    error,
    id: invitationId,
  } = invitation;

  const getListDoctors = (text, isLoadMore = false) => {
    dispatch(
      searchDoctors(
        doctorId,
        {
          patientId,
          consultId,
          forPatientId,
          text,
          limit,
          offset,
        },
        isLoadMore,
      ),
    );
  };

  useEffect(
    () => () => {
      offset = 0;
      interval = null;
      dispatch(resetInvitationState());
    },
    [dispatch],
  );

  useEffect(() => {
    if (creatingInvitation === 1) {
      // const mewLatestConsult = {
      //   invitation: invitationId,
      // };
      // dispatch(updateEntities(WEBCHAT, 'consult', consultId, mewLatestConsult));
      close();
    }
  }, [creatingInvitation, dispatch, close, invitationId, consultId]);

  const onSearch = value => {
    setSearch(value);
    clearTimeout(interval);
    if (value !== '') {
      interval = setTimeout(() => {
        offset = 0;
        getListDoctors(value);
      }, 500);
    }
  };

  const onClickItem = (doctor, isActive) => {
    if (isActive) {
      setSelectedDoctor(prev => prev.filter(item => item.id !== doctor.id));
    } else {
      setSelectedDoctor(prev => [...prev, doctor]);
    }
  };

  const onRemoveSelectedDoctor = doctor => {
    setSelectedDoctor(prev => prev.filter(item => item.id !== doctor.id));
  };

  const onAddDoctor = async () => {
    const doctorIds = selectedDoctor.map(i => i.id);
    if (doctorIds.length > 0) {
      await dispatch(inviteDoctorsToConsult(consultId, { doctorIds }));
    }
  };

  const loadMoreDoctor = () => {
    offset += limit;
    getListDoctors(search, true);
  };

  return (
    <Modal size="small" open className="doctor_invite" closeOnDimmerClick>
      <Modal.Header>Add Provider</Modal.Header>
      <Modal.Content>
        <ModuleSearch onSearch={onSearch} search={search} loading={loadDoctor === 0} />
        {creatingInvitation === 2 && (
          <div style={{ color: 'red', padding: '8px 0' }}>{error.data.message}</div>
        )}
        <DoctorSelected selectedItems={selectedDoctor} onRemove={onRemoveSelectedDoctor} />
        <DoctorList
          list={doctors}
          onClickItem={onClickItem}
          selectedItems={selectedDoctor}
          loadDoctor={loadMoreDoctor}
          showLoadMore={(meta?.pagination?.offset || 0) + limit < meta?.pagination?.total}
          loading={loadDoctor === 0}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button
          primary
          disabled={selectedDoctor === null || creatingInvitation === 0}
          onClick={onAddDoctor}
          loading={creatingInvitation === 0}
          content="Add"
        />
      </Modal.Actions>
    </Modal>
  );
};

ModalDoctorInvite.propTypes = {
  close: func.isRequired,
  conversationActive: shape({}).isRequired,
  doctorId: number.isRequired,
};

ModalDoctorInvite.defaultProps = {};

export default memo(ModalDoctorInvite);
